import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import {createRoot} from 'react-dom/client';
import './index.css';
import '@styles/styles.scss';
import '@styles/tailwind.css';
import './lang/i18n';
import {StoreProvider} from 'easy-peasy';
import React from "react";
import * as Sentry from "@sentry/react";
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from '@store';

// Check for array method Matches support - IE alternative
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

const environment = process.env.REACT_APP_ENVIRONMENT;
if (environment === 'production') {
    Sentry.init({
        dsn: "https://68e0e3eaa977473bc49449186a1fa201@o4508930925985792.ingest.de.sentry.io/4508931204251728",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        environment: 'production',
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

const container = document.getElementById('root');
const root = createRoot(container);
// eslint-disable-next-line import/no-named-as-default-member
root.render(
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <StoreProvider store={store}>
        <App />
      </StoreProvider>
    </Sentry.ErrorBoundary>
);

serviceWorker.unregister();
